var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`swiper-btn swiper-btn_${_vm.type}`,on:{"click":_vm.handClick}},[_c('div',{staticClass:"swiper-content"},[_c('img',{attrs:{"src":_vm.data[_vm.type].url,"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.data[_vm.type].txt))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }